// @flow
import type { ProductPayload } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import type { GandiFormSelectOption } from '../types';

export function useDomainPerksDetails(): Array<{
  label: string,
  detail?: string,
}> {
  const { __ } = useTranslator();

  return [
    {
      label: __('SSL Certificate - Standard Single address'),
      detail: __('Included by Gandi free for the first year'),
    },
    {
      label: __('Privacy options'),
      detail: __('Whois privacy & email obfuscation when available'),
    },
  ];
}

export function useWebhostingPerksDetails(
  size: ProductPayload['size'],
): Array<{ label: string, detail?: string }> {
  const { __ } = useTranslator();

  const perksDetails: Array<{ label: string, detail?: string }> =
    size === 'starter'
      ? []
      : [
          {
            label: __(
              'Unlimited free standard SSL certificate for every site hosted.',
            ),
          },
        ];

  perksDetails.push({
    label: __('Privacy options'),
    detail: __('Whois privacy & email obfuscation when available'),
  });

  return perksDetails;
}

export function usePlanOptions(): Array<GandiFormSelectOption<number>> {
  const { __ } = useTranslator();

  // The value is the duration of the subscription in months
  return [
    { text: __('monthly'), value: 1 },
    { text: __('yearly'), value: 12 },
  ];
}
